import { Component, HostListener, signal, ElementRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimateDirective } from '../directives/animate.directive';

@Component({
  selector: 'app-authority',
  imports: [CommonModule, AnimateDirective],
  template: `
    <section class="py-16 relative overflow-hidden bg-white">
      
      <!-- Parallax Background -->
      <div class="absolute inset-0 bg-cover bg-center will-change-transform"
           style="background-image: url('https://c4mkt-my.sharepoint.com/:u:/g/personal/bruno_c4marketing_com_br/IQBuAshMhy7DRK6BWLnS1gy4AcxM0iMjtu5xSWB43OwTHyc?e=R4jEID&download=1'); height: 120%; top: -10%;"
           [style.transform]="'translateY(' + (offsetY() * 0.03) + 'px)'">
      </div>

      <!-- White Overlay for text readability (Light Theme) -->
      <div class="absolute inset-0 bg-white/90"></div>

      <div class="container mx-auto px-4 text-center relative z-10">
        <h2 appAnimate class="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111111] mb-6 max-w-5xl mx-auto leading-tight">
          A solução de controle térmico mais completa e juridicamente robusta do mercado nacional.
        </h2>
        <p appAnimate [delay]="150" class="text-gray-600 mb-8 text-lg max-w-4xl mx-auto font-medium">
          Já são inúmeras as empresas beneficiadas por essa metodologia, referência em monitoramento da pausa térmica NR 36.
        </p>
        <div appAnimate [delay]="300" class="inline-block border border-[#FF5500]/20 bg-[#FF5500]/5 backdrop-blur-sm rounded-xl px-8 py-6 shadow-sm">
          <p class="text-[#FF5500] font-bold text-lg md:text-xl">
            Aumente sua produtividade em até 35%, mantendo a segurança jurídica da sua operação.
          </p>
        </div>
      </div>
    </section>
  `
})
export class AuthorityComponent {
  private el = inject(ElementRef);
  offsetY = signal(0);

  @HostListener('window:scroll')
  onScroll() {
    const rect = this.el.nativeElement.getBoundingClientRect();
    // Calculate offset relative to viewport center for smoother parallax when entering/leaving view
    const viewHeight = window.innerHeight;
    if (rect.top < viewHeight && rect.bottom > 0) {
      this.offsetY.set(rect.top - viewHeight / 2);
    }
  }
}